// import createLogger from '../plugins/logger';

export default process.env.NODE_ENV !== 'production'
  ? []
  : []; // disable this on go-live